import { useCallback, useEffect } from 'react';
import { useTableStore } from './selectTableStore';
import { adminAPI } from 'services/admin';

export const useTableWithCheck = ({ url, listKey }) => {
  const {
    data,
    setData,
    setCount,
    setIsLoading,
    selectedItems,
    setSelectedItemsByListId,
  } = useTableStore();

  const getDataTable = useCallback(
    async ({ page = 0, filter = '' } = {}) => {
      setIsLoading(true);
      try {
        const offset = page * 10;
        const filterValue = filter ? `&${filter}` : '';
        const path = `${url}${offset}${filterValue}`;
        const response = await adminAPI.get(path);

        setCount(response.totalItemsCountFiltered);
        setData(response[listKey]);

        return response;
      } finally {
        setIsLoading(false);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [listKey, url]
  );

  const onChangeSelected = (listId, selected) => {
    const allSelectedData = [
      ...(selectedItems?.[listId] || []),
      ...data,
    ].reduce((acc, currentValue) => {
      if (selected[currentValue.id]) {
        const itemFromSelect = selectedItems?.[listId]?.find(
          i => i.contentId === currentValue.id
        );
        return { ...acc, [currentValue.id]: itemFromSelect || currentValue };
      }
      return acc;
    }, {});

    setSelectedItemsByListId(listId, Object.values(allSelectedData));
  };

  useEffect(() => {
    getDataTable();
  }, [getDataTable]);

  return {
    onChangeSelected,
    getDataTable,
  };
};
